var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.08,11.36a2.4,2.4,0,0,0-1.67-.69H21.93V7.81a1.7,1.7,0,0,0-.14-.71,1.75,1.75,0,0,0-.4-.6,2,2,0,0,0-.6-.4A1.94,1.94,0,0,0,20.08,6H14.84A1.84,1.84,0,0,0,13,7.81v2.86H8.59a2.4,2.4,0,0,0-1.67.69A2.36,2.36,0,0,0,6.23,13V26.41a2.36,2.36,0,0,0,2.36,2.36H26.41a2.36,2.36,0,0,0,2.36-2.36V13A2.36,2.36,0,0,0,28.08,11.36ZM14.6,7.81a.2.2,0,0,1,0-.11.24.24,0,0,1,.06-.09l.09-.05a.22.22,0,0,1,.11,0h5.24a.27.27,0,0,1,.19.08.32.32,0,0,1,.07.19v2.86H14.6ZM8,12.47a.75.75,0,0,1,.55-.23H26.41a.75.75,0,0,1,.55.23.78.78,0,0,1,.23.55V18.9H21.93V17.5a.76.76,0,0,0-.05-.3.78.78,0,0,0-.17-.26.9.9,0,0,0-.26-.17.8.8,0,0,0-.3-.06H13.81a.79.79,0,0,0-.79.74V18.9H7.81V13A.78.78,0,0,1,8,12.47Zm12.38,5.76v3h-5.8v-3ZM27,27a.76.76,0,0,1-.55.23H8.59a.79.79,0,0,1-.78-.78V20.48H13V22a1,1,0,0,0,.06.33,1,1,0,0,0,.17.27.84.84,0,0,0,.28.18.85.85,0,0,0,.32,0h7.34a.82.82,0,0,0,.3-.07.84.84,0,0,0,.24-.18,1,1,0,0,0,.16-.26.8.8,0,0,0,0-.31V20.48h5.26v5.93A.76.76,0,0,1,27,27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.b8ad04677055a50be9e304fcb6242b74.svg";
export { ForwardRef as ReactComponent };